import React, { useState } from 'react';

const BusinessPartnerRegister = () => {
  const [filterType, setFilterType] = useState('group');
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    // Handle search logic here
    alert(`Searching for "${searchQuery}" in ${filterType}s`);
  };

  return (
    <div className="p-4 bg-white rounded shadow-md flex flex-wrap items-center gap-4">
      {/* Radio Buttons */}
      <div className="flex items-center space-x-4">
        <label className="inline-flex items-center text-sm">
          <input
            type="radio"
            name="filter"
            value="group"
            checked={filterType === 'group'}
            onChange={(e) => setFilterType(e.target.value)}
            className="form-radio text-blue-600"
          />
          <span className="ml-2">Group</span>
        </label>

        <label className="inline-flex items-center text-sm">
          <input
            type="radio"
            name="filter"
            value="ledger"
            checked={filterType === 'ledger'}
            onChange={(e) => setFilterType(e.target.value)}
            className="form-radio text-blue-600"
          />
          <span className="ml-2">Ledger</span>
        </label>
      </div>

      {/* Search Input */}
      <input
        type="text"
        placeholder={`Search ${filterType}s...`}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-60"
      />

      {/* Button */}
      <button
        onClick={handleSearch}
        className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-4 py-2 rounded"
      >
        Search
      </button>
    </div>
  );
};

export default BusinessPartnerRegister;
